import { createAction, props } from '@ngrx/store';

import { ToastState } from '../reducers/toast.reducer';

const prefix = '[Toast]';

export const loadingToastAction = createAction(
  `${prefix} loading`,
  props<ToastState['options']>()
);
export const errorToastAction = createAction(
  `${prefix} error`,
  props<ToastState['options']>()
);
export const infoToastAction = createAction(
  `${prefix} info`,
  props<ToastState['options']>()
);
export const successToastAction = createAction(
  `${prefix} success`,
  props<ToastState['options']>()
);
export const clearToastAction = createAction(`${prefix} clear`);
